module.exports = __webpack_public_path__ + "static/media/ne.39adb9f9.png";